module.exports = __webpack_public_path__ + "img/airco.0dea47ca.svg";